import { render, staticRenderFns } from "./chartcard.vue?vue&type=template&id=c1464f52&scoped=true&"
import script from "./chartcard.vue?vue&type=script&lang=js&"
export * from "./chartcard.vue?vue&type=script&lang=js&"
import style0 from "./chartcard.vue?vue&type=style&index=0&id=c1464f52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1464f52",
  null
  
)

export default component.exports